export default function ($scope, $state, $filter, adminService) {
  let vm;
  const uiSref = 'ownerShow.ownerPayments({id: row.ownerId})';

  class AdminPaymentsListCtrl {
    constructor () {
      vm = this;
      vm.name = 'adminPaymentsList';

      vm.tableHeadList = [
        { name: 'createdAt', type: 'customFunction', customFunction: vm.getPaymentDate, label: 'תאריך ביצוע תשלום', sortable: true, uiSref },
        { name: 'owner.name', label: 'ארגון', sortable: true, uiSref },
        { name: 'sum', label: 'סכום תשלום', type: 'currency', currency: '₪', sortable: true, uiSref },
        { name: 'lastCardDigits', type: 'customFunction', customFunction: vm.getCardNumber, label: 'אמצעי תשלום', sortable: true, uiSref },
        { name: 'type', label: 'מקור', type: 'customFunction', customFunction: vm.getPaymentType, sortable: true, uiSref },
        { name: 'description', label: 'מטרת תשלום', sortable: true, uiSref },
        { name: 'dealResponse', label: 'סטטוס מענה', type: 'customFunction', customFunction: vm.getPaymentStatus, sortable: true, uiSref },
        { name: 'operationResponseText', label: 'תקין', sortable: true, uiSref },
        { name: 'invoiceDocumentUrl', label: 'חשבונית / קבלה', type: 'customFunction', customFunction: vm.getPaymentInvoice, clickFunction: vm.downloadInvoice }
      ];
    }

    getTransactionsList (args) {
      return adminService.getAllPayments(args);
    }

    getPaymentDate (row) {
      return $filter('date')(row.createdAt, 'dd/MM/yyyy HH:mm');
    }

    getCardNumber (row) {
      if (row.lastCardDigits) {
        return '**** ' + row.lastCardDigits;
      }
    }

    getPaymentType (row) {
      return row.type === 'charge' ? 'ידני' : row.type === 'debit' ? 'הו"ק' : '';
    }

    getPaymentStatus (row) {
      return row.dealResponse === '0' ? '<span class="badge badge-success">תקין</span>' : row.dealResponse;
    }

    getPaymentInvoice (row) {
      return row.invoiceDocumentUrl ? '<a target="_blank" class="btn btn-default btn-sm" href="' + row.invoiceDocumentUrl + '">הורדת חשבונית / קבלה</a>' : '';
    }

    downloadInvoice ($event, row) {
      window.open(row.invoiceDocumentUrl, '_blank');
    }
  }

  return new AdminPaymentsListCtrl();
}
